var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"status is-transparent d-flex p-0",class:[
        _vm.isSuccess || (_vm.value >= _vm.goal && _vm.value !== 0)
            ? 'text-success'
            : 'text-danger'
    ]},[_c('a-icon',{attrs:{"icon":_vm.isSuccess || (_vm.value >= _vm.goal && _vm.value !== 0)
                ? 'Success'
                : 'Warning'}}),_c('span',[_vm._v(_vm._s(_vm._f("number")(_vm.value))+" / "+_vm._s(_vm._f("number")(_vm.displayGoal))+" "),(_vm.showProgress)?_c('span',[_vm._v("("+_vm._s(_vm.progress)+"%)")]):_vm._e()])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }